// Chakra imports
import {
    Table,
    Tbody,
    Tr,
    Td,
    TableContainer, Text, useColorModeValue, Icon, Thead, Th, Link,
} from '@chakra-ui/react'
import React, {useState} from "react";
import {FaEye, FaEyeSlash} from "react-icons/fa";


const TransactionLink = ({ title, value, link }) => {

    const textColor = useColorModeValue("gray.700", "white");
    const [selected, setSelected] = useState(true)

    const toggle = () => {
        setSelected(!selected)
    }

    return (
        <>
            <TableContainer>
                <Table bg={"#7fdfd6"} colorScheme='teal'>
                    <Thead>
                        <Tr>
                            <Th width={"100%"}>
                                <Text
                                    fontSize='md'
                                    color={textColor}
                                    cursor="pointer"
                                    onClick={toggle}
                                >
                                    {title}
                                </Text>
                            </Th>
                            <Th>
                                <Icon
                                    as={(selected) ? FaEye : FaEyeSlash}
                                    color="gray.400"
                                    cursor="pointer"
                                    onClick={toggle}
                                    style={{
                                        "width": "18px",
                                        "height": "18px"
                                    }}
                                />
                            </Th>
                        </Tr>
                    </Thead>
                </Table>
            </TableContainer>
            {selected &&
            <TableContainer>
                <Table>
                    <Tbody width={"100%"}>
                        <Tr>
                            <Td width="300px" fontWeight='bold'>{title}</Td>
                            <Td width="300px">
                                <Link color="teal.500" href={link} isExternal>
                                    {<pre-wrap>{value}</pre-wrap>}
                                </Link>
                            </Td>
                        </Tr>
                    </Tbody>
                </Table>
            </TableContainer>
            }
        </>
    )

}

export default TransactionLink;

